var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounsel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.807,
    height: 159,
    viewBox: "0 0 158.807 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 79,
    cy: 79.5,
    rx: 79,
    ry: 79.5,
    transform: "translate(0.023)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(-1257 -8210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M79.4,0A79.4,79.4,0,1,1,0,79.4,79.4,79.4,0,0,1,79.4,0Z",
    transform: "translate(1257 8210)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_89",
    "data-name": "Mask Group 89",
    transform: "translate(1257.389 8210)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(34.705 36.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    transform: "translate(0 15.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(25.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(8.795 46.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M52.05,175.517,63.83,186.33l3.756-4.248L52.05,166.591Z",
    transform: "translate(-52.05 -164.221)",
    fill: "#e8af93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M73.675,165.355l-21.625,1.29v1.08l15.535,15.49,6.089-6.887Z",
    transform: "translate(-52.05 -165.355)",
    fill: "#dba18f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M56.765,148.547c-3,1.158-6.2,3.475-6.611,6.891-.3,2.453.823,4.849.572,7.344-.067.656-.163,2.141-1.164,1.483-.416-.272-.2-1.086-.643-1.414-.984-.731-1.389.541-1.427,1.3a16.788,16.788,0,0,0,1.44,8.069c.692,1.414,1.657,1.816,2.622,2.841,1.068,1.132.89,3.355,1.291,4.77a8.191,8.191,0,0,0,1.235,2.6c1.185,1.636,3.245,2.4,4.6,3.884a15.246,15.246,0,0,0,4.191,3.679,7.585,7.585,0,0,0,3.608.493V148.4A15.4,15.4,0,0,0,56.765,148.547Z",
    transform: "translate(-47.465 -135.339)",
    fill: "#f9cfb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M76.9,164.15c-.036-.756-.443-2.027-1.427-1.3-.445.328-.226,1.141-.643,1.414-1,.658-1.1-.827-1.164-1.483-.251-2.5.871-4.891.572-7.344-.416-3.416-3.608-5.733-6.611-6.891a15.422,15.422,0,0,0-9.983-.067c-.086-.031-.18-.052-.267-.079v42.086c.088,0,.178,0,.267-.008A8.044,8.044,0,0,0,61.521,190a15.281,15.281,0,0,0,4.193-3.679c1.356-1.486,3.414-2.248,4.6-3.884a8.2,8.2,0,0,0,1.239-2.6c.4-1.416.221-3.638,1.289-4.77.965-1.024,1.93-1.427,2.622-2.841A16.787,16.787,0,0,0,76.9,164.15Z",
    transform: "translate(-38.363 -135.34)",
    fill: "#e5bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M48.626,166.679a11.126,11.126,0,0,1,.416,3.882c-.006.188-.021.476-.015.786h1.8a9.131,9.131,0,0,0-.011-.951,26.245,26.245,0,0,1,.038-2.881c.073-1.379-.1-2.8.038-4.168a7.352,7.352,0,0,1,6.87-6.418c2.516-.2,5.037.32,7.557.324,3.115.008,4.521-1.492,6.978-3.021.658-.41.267-.464.953-.288.445.113,1.017.721,1.4.957,2.33,1.429,6.525,2.846,7.2,5.86a29.288,29.288,0,0,1,.357,7.2,26.787,26.787,0,0,0-.226,3.385h1.4c.451-1.454,1.049-3.431,1.2-4.195a39.016,39.016,0,0,0,.595-5.708c.508-4.615.761-9.038-2.083-12.908-3.046-4.145-7.559-6.569-9.97-6.26-.138.017-1.77.165-1.563.349-.859-.773-2.365-.829-3.428-1.082-5.658-1.348-12.814,2.169-16.927,5.929-4.341,3.967-3.7,9.072-3.205,13.973A29.918,29.918,0,0,0,48.626,166.679Z",
    transform: "translate(-47.301 -141.249)",
    fill: "#5f5c54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(0 54.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M52.05,186.748c-.075-.8,10.363-11.763,10.363-11.763H63.75l9.926,11.077L63.309,213.791Z",
    transform: "translate(-17.938 -164.426)",
    fill: "#bad1dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M65.719,198.655,62.19,182.633a2.178,2.178,0,0,1,.205-1.5l1.339-2.52a.4.4,0,0,0-.09-.439q-.774-.771-1.548-1.538a4.146,4.146,0,0,1-.978-1.134c-.144-.326-.545-1.059-1.011-.748-.407.272-.543.7-.806,1.061a9.438,9.438,0,0,1-.992.986q-.69.685-1.381,1.373a.406.406,0,0,0-.092.439l1.341,2.52a2.188,2.188,0,0,1,.2,1.5l-3.529,16.021a.4.4,0,0,0,.017.242l4.891,12.563a.748.748,0,0,0,1.053,0L65.7,198.9A.4.4,0,0,0,65.719,198.655Z",
    transform: "translate(-15.376 -164.707)",
    fill: "#3d5872"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    transform: "translate(0 5.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M34.265,219.784H78.612l.081-18.423-8.228-17.68-3.4-11.3-.364.111c-.852.251-3.123.938-6,1.8-7.73,2.344-19.786,6-20.109,6.22a52.393,52.393,0,0,0-2.572,4.866,35.625,35.625,0,0,0-3.754,15.91Z",
    transform: "translate(-34.265 -172.386)",
    fill: "#31353e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M102.7,198.042a23.571,23.571,0,0,0-2.438-10.432c-1.816-3.681-3.472-6.951-3.675-7.089-.33-.219-12.387-3.876-20.116-6.22-2.867-.865-5.144-1.546-6-1.8l-.37-.111-4.745,15.291-7.935,13.545-.1,18.563H102.7Z",
    transform: "translate(-13.091 -172.386)",
    fill: "#252930"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M75.077,169.48l-10.7,9.659a.433.433,0,0,1-.575,0l-10.7-9.659L50.7,176.49,55.325,191.8l8.409-11.829a.43.43,0,0,1,.7,0L72.845,191.8l4.626-15.312Z",
    transform: "translate(-19.176 -169.48)",
    fill: "#e4f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M47.929,180.7l18.893,22h0l20.066-22-5.618-1.485,6.456-1.989a23.3,23.3,0,0,0-1.847-3c-2.867-.543-5.152-2.325-6-2.486L74.768,182.6l-1.646,3.059-6.034,11.111-5.4-11.111L58.7,180.1l-3.759-8.359c-.852.155-3.126,1.943-6.005,2.486a24.273,24.273,0,0,0-1.849,3l6.458,1.989Z",
    transform: "translate(-22.498 -167.408)",
    fill: "#1f232d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(5.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482",
    transform: "translate(18.588 9.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M87,138.568v22.717a94.1,94.1,0,0,1-10.281,1.623,93.12,93.12,0,0,1-10.049.48,94.416,94.416,0,0,1-19.134-2.1V141.046L59.5,140.3Z",
    transform: "translate(-46.38 -138.568)",
    fill: "#31353e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M87.559,138.568v22.717a94.1,94.1,0,0,1-10.281,1.623L48.1,147.086l-1.16-.677,1.16-.516L60.051,140.3Z",
    transform: "translate(-46.935 -138.568)",
    fill: "#252930"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M37.244,140.009,75.129,133.4l40.015,8.673L72.228,160.762Z",
    transform: "translate(-37.244 -133.401)",
    fill: "#1f232d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M37.244,140.009,75.129,133.4l40.015,8.673L71.723,155.7Z",
    transform: "translate(-37.244 -133.401)",
    fill: "#383f4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M61.359,136.929c0,1.026-1.717,1.859-3.834,1.859s-3.834-.832-3.834-1.859,1.717-1.859,3.834-1.859S61.359,135.9,61.359,136.929Z",
    transform: "translate(-22.145 -131.869)",
    fill: "#1d1f25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(8.226 3.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M42.648,149.6l-.052,0a1.113,1.113,0,0,1-1.063-1.162l.033-.8c.121-3.088.234-6.009,3.671-7.032l24.137-5.284a1.114,1.114,0,0,1,.478,2.177l-24.058,5.265c-1.68.5-1.87,1.626-2,4.962l-.033.813A1.115,1.115,0,0,1,42.648,149.6Z",
    transform: "translate(-41.532 -135.297)",
    fill: "#efcb0e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    transform: "translate(5.64 16.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M40.184,148.433c0,5.039,3.568,9.124,3.568,9.124l.109-.13V142.107C41.968,142.2,40.184,143.578,40.184,148.433Z",
    transform: "translate(-40.184 -142.097)",
    fill: "#efcb0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M42.318,142.1c-.073,0-.144.006-.217.01v15.319c.579-.708,3.46-4.458,3.46-8.994C45.561,143.4,44.288,142.1,42.318,142.1Z",
    transform: "translate(-38.424 -142.102)",
    fill: "#e2b90e"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounsel4);
export default __webpack_public_path__ + "static/media/counsel4.c646e36d0a15fc9ab9d36c19cd208bc2.svg";
export { ForwardRef as ReactComponent };